import { render, staticRenderFns } from "./amministrazione.vue?vue&type=template&id=f9f6aece&scoped=true&"
import script from "./amministrazione.vue?vue&type=script&lang=js&"
export * from "./amministrazione.vue?vue&type=script&lang=js&"
import style0 from "./amministrazione.vue?vue&type=style&index=0&id=f9f6aece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f6aece",
  null
  
)

export default component.exports